import { IDataQualityIndicatorItemInfo } from '../../catalog/models/IDataQualityIndicatorItemInfo';
import { IRemoteRefreshPropertiesInfo } from '../../extractRefresh/models/IRemoteRefreshPropertiesInfo';
import { IDatasourceUsageInfo } from '../../spacesPlatform/models/IUsageInfo';
import {
  ICertifiableItemInfo,
  ICreatedItemInfo,
  IDescriptionItemInfo,
  IDownloadItemInfo,
  IExplorableItemTypeInfo,
  IExtractItemInfo,
  IFavoriteItem,
  IIdItemInfo,
  IItemStatisticsInfo,
  ILocationItemInfo,
  ILuidItemInfo,
  IModifiedByItemInfo,
  INamedItemInfo,
  IOwnedItemInfo,
  IProjectItemInfo,
  ISpaceTypeInfo,
  ITaggedItemInfo,
  IUpdatedItemInfo,
} from '../../spacesPlatform/models/resourceInfoParts';
import { IWorkbookInfo } from '../../workbook/models/IWorkbookInfo';
import { IDataConnectionInfoProperties } from '../dataConnection/models/IDataConnectionInfo';

export interface IDataSourceBasicInfo extends
  INamedItemInfo,
  IOwnedItemInfo,
  IModifiedByItemInfo,
  IProjectItemInfo,
  ILocationItemInfo,
  ILuidItemInfo
{
  workbook?: INamedItemInfo;
  datasourceLuid?: string; // defined for data source returned from CRASS/content-exploration
}

export interface IPublishedDatasourceInfoProperties{
  hasExtracts: boolean;
  lastRefreshedAt?: string;
  hasEncryptableExtracts: boolean;
  connectedWorkbooksCount: number;
  dependentDataSourcesCount: number;
  extractEncryptionState: string;
}

export interface IDataSourceBase extends
  IDataSourceBasicInfo,
  IDataConnectionInfoProperties,
  IDownloadItemInfo,
  IExtractItemInfo,
  IFavoriteItem,
  ITaggedItemInfo,
  IUpdatedItemInfo,
  IDataQualityIndicatorItemInfo,
  IExplorableItemTypeInfo<'datasource'>,
  ISpaceTypeInfo<'datasource'>
{
  certificationDetails: ICertifiableItemInfo;
  publishedDatasourceDetails?: IPublishedDatasourceInfoProperties;

  // Uniquely identifies a datasource on a site.
  // It is essentially he name of the data source,  normalized and encoded to be suitable for use in path of a URL.
  // (AKA "repositoryUrl" on the backend)
  urlName: string;
  connectedWorkbooksCount: number;
  //Number of published or embedded datasources that depend on this datasource (logical upstream dependency).
  dependentDataSourcesCount?: number;
  dataConnectionsCount: number;

  // the "idForFavoriting" field exists while the backend transitions away from UnifiedDatasources.
  // It is used only in special cases (currently only favoriting and finding data connections by
  // data source) where the backend can't map the unified datasource ID to the published datasource
  // ID. In the future, once datasource IDs have been standardized, these use cases will use the
  // data source's "id" field, same as in the rest of the app.
  idForFavoriting: string;

  isHierarchical: boolean;

  isExtractOnly: boolean;
  isFileBased: boolean;
  hasExternalMetric: boolean;
}

export interface IDataSourceInfo extends
  IDataSourceBase,
  IItemStatisticsInfo<IDatasourceUsageInfo>,
  IDescriptionItemInfo
{
}

export interface IDataSourceDetailInfo extends
  IDataSourceBase,
  ICreatedItemInfo,
  IDescriptionItemInfo,
  IRemoteRefreshPropertiesInfo
{
  connectedUsersCount: number;
  workbook?: IWorkbookInfo;
}

export interface IDataSourceDetailInfoWithUsage extends
  IDataSourceDetailInfo,
  IItemStatisticsInfo<IDatasourceUsageInfo>
{
}

export enum ExtractEncryptionState {
  unencrypted = 'unencrypted',
  encrypted = 'encrypted',
  pendingEncryption = 'pendingEncryption',
  pendingDecryption = 'pendingDecryption'
}

export enum ExtractCreationState {
  pending = 'pendingCreation'
}

export interface IDataSourceMiniInfo extends
  INamedItemInfo,
  IIdItemInfo
{
}
